import { API, USE_CASE, USE_CASE_TAGS } from '../constants';

// Use Case Status
export const UC_STATUS = {
  TESTING: 'TESTING',
  CERTIFICATION: 'CERTIFICATION',
  CERTIFICATION_WITH_WHITELIST: 'CERTIFICATION_WITH_WHITELIST',
  LIVE: 'LIVE',
  UNAVAILABLE: 'UNAVAILABLE',
} as const;

export const UC_STATUS_HIERARCHY = {
  [UC_STATUS.LIVE]: 5,
  [UC_STATUS.CERTIFICATION_WITH_WHITELIST]: 4,
  [UC_STATUS.CERTIFICATION]: 3,
  [UC_STATUS.TESTING]: 2,
  [UC_STATUS.UNAVAILABLE]: 1,
};

export type TUseCaseTag = (typeof USE_CASE_TAGS)[keyof typeof USE_CASE_TAGS];
export type TUseCaseTest = Record<TUseCaseTag, any[]>;
export type TUseCaseStatus =
  | typeof UC_STATUS.TESTING
  | typeof UC_STATUS.CERTIFICATION
  | typeof UC_STATUS.LIVE
  | typeof UC_STATUS.UNAVAILABLE;
export type TUseCaseType = typeof USE_CASE | typeof API;

export const PLATFORMS = {
  IOS: 'IOS',
  ANDROID: 'ANDROID',
} as const;

export interface IUseCaseV2 {
  id: string;
  environment_id: string;
  tag: string;
  status: TUseCaseStatus;
  platform: typeof PLATFORMS.IOS | typeof PLATFORMS.ANDROID;
  carrier_selected: boolean;
}
export interface IUseCaseResource {
  title: string;
  tag: string;
  description: string;
  status: string;
  parameters: string[];
  query_parameters: string[];
  sorting_order: number;
  long_description: string;
  visibility: string;
}

export interface ISelectedUseCase {
  id: string;
  organisation_id: string;
  environment_id: string;
  use_case_tag: TUseCaseTag;
  status: TUseCaseStatus;
  eligibility_status: 'TESTING' | 'PRODUCTION';
  eligibility_status_android: 'TESTING' | 'PRODUCTION';
}

export interface ISelectedUseCaseApi {
  api: {
    title: string;
    tag: string;
    description: string;
    status: string;
    parameters: {
      name: string;
      type: string;
      required: boolean;
      options: unknown[];
      belongs_to: unknown;
      contains: unknown;
    }[];
    sorting_order: number;
    group: string;
    request_type: unknown;
    incoming: boolean;
    query_parameters?: string;
  };
  use_case_tags: string[];
}

interface PlatformData {
  id: string;
  status: string;
  carrier_selected: boolean;
}

export interface GroupedUseCase {
  tag: string;
  environment_id: string;
  status: string;
  IOS: PlatformData | null;
  ANDROID: PlatformData | null;
}

export interface BulkSelectUseCasePayload {
  envId: string;
  ids: string[];
  selected: boolean;
}

export interface IMutateTestCaseRequestV2 {
  api_tag?: string;
  use_case_tag?: string;
  test_case_tag: string;
  params_model_version: '1.0.0';
  data: string | Record<any, string>;
}

export interface IPostUseCaseVariables {
  envId: string;
  payload: IMutateTestCaseRequestV2;
}
